import * as React from "react";
const SvgFiRrB = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-b_svg__a)">
      <path
        fill="#062147"
        d="M15.5 24H7c-2.757 0-5-2.243-5-5V5c0-2.757 2.243-5 5-5h5.5c5.786-.075 8.693 7.283 4.51 11.177 7.371 1.84 6.167 12.716-1.51 12.823M4 13v6c0 1.654 1.346 3 3 3h8.5c5.935-.156 5.931-8.846 0-9zm0-2h8.5c5.935-.156 5.931-8.846 0-9H7C5.346 2 4 3.346 4 5z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-b_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrB;
